<template>
  <!-- 新增/编辑 -->
  <el-dialog
    :title="title ? title : '编辑'"
    :visible.sync="dialogVisible"
    width="400px"
    :close-on-click-modal="false"
    :append-to-body="appendToBody"
    @close="handleClose"
  >
    <el-form ref="form" label-width="80px" :rules="rules" :model="form">
      <!-- 序号 -->
      <el-form-item prop="sort" label-width="80px" label="序号" required>
        <el-input
          v-model="form.sort"
          placeholder="请输入序号"
          clearable
          style="width: 200px"
          type="number"
          maxlength="9"
        ></el-input>
      </el-form-item>
      <!-- 分类名称  -->
      <el-form-item prop="name" label-width="80px" label="分类名称" required>
        <el-input
          v-model="form.name"
          placeholder="请输入分类名称"
          clearable
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item prop="" label-width="70px" label="">
        <el-button
          type="primary"
          @click="submit"
          style="width: 120px; margin-left: 10px"
          >确认</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {
  goodsClinicEssentialBasicsConfigs,
  goodsClinicEssentialBasicsConfigsUpdate,
} from "@/api/recommendationHome";

export default {
  components: {},
  props: {
    appendToBody: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      title: "",
      dialogVisible: false,
      rules: {
        sort: [
          { required: true, message: "请输入序号", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              console.log("value", value, typeof value);
              const reg = /^[0-9]+$/;
              if (!reg.test(value)) {
                callback(new Error("请输入数字"));
              } else {
                callback();
              }
            },
          },
        ],
        name: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
      },
      form: {
        sort: "",
        name: "",
        id: "",
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    showAdd() {
      this.title = "新增";
      this.dialogVisible = true;
      this.form = {
        sort: "",
        name: "",
        id: "",
      };
    },
    showEdit(row) {
      this.title = "编辑";
      this.dialogVisible = true;
      if (row) {
        this.form = {
          sort: row.serialNumber,
          name: row.classifyName,
          id: row.id,
        };
      }
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log("验证通过-------");
          if (this.flag) {
            return;
          }
          this.flag = true;
          let params = {
            serialNumber: this.form.sort,
            classifyName: this.form.name,
            id: this.form.id,
          };
          if (this.form.id) {
            goodsClinicEssentialBasicsConfigsUpdate(params)
              .then((res) => {
                this.dialogVisible = false;
                this.$emit("refreshList");
              })
              .finally(() => {
                this.flag = false;
              });
          } else {
            goodsClinicEssentialBasicsConfigs(params)
              .then((res) => {
                this.dialogVisible = false;
                this.$emit("refreshList");
              })
              .finally(() => {
                this.flag = false;
              });
          }
        } else {
          console.log("invalid", valid);
        }
      });
    },
    handleClose() {
      this.$refs.form.resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-search {
  display: flex;
  justify-content: space-between;
}
</style>
